import React from 'react';
import { Menu } from 'lucide-react';
import MenuEditor from './MenuEditor.jsx';

const MenuSettingsIndex = () => {
    return (
        <div>
            {/* Page Header */}
            <div className="mb-4">
                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                    <div>
                        <h1 className="h2 fw-bold text-dark d-flex align-items-center gap-2 mb-2">
                            <Menu size={32} className="icon-settings" />
                            Menüs
                        </h1>
                        <p className="text-muted mb-0">
                            Konfigurieren Sie die Darstellung und Reihenfolge Ihrer Menüpunkte.
                        </p>
                    </div>
                </div>
            </div>
            <MenuEditor />
        </div>
    );
};

export default MenuSettingsIndex;
